module.exports = __webpack_public_path__ + "static/media/GenericActivity.6303a9c9.png";